import api from "../../api.service"
import { getPaginatedResponse } from "../utils"

import queryString from "query-string"

/**
 * For query parameters, see:
 * https://docs.api.missionx.ai/operation/operation-get-projects
 */
export async function getMissions(queryParams = {}, signal) {
    try {
        const qs = queryString.stringify(queryParams)
        const res = await api.get(`/v2/missions?${qs}`, { signal })

        return getPaginatedResponse({
            ...res.data,
            value: res.data?.value,
        })
    } catch (err) {
        if (err.name === "CanceledError") {
            return {
                value: [],
                nextLink: null,
                hasNext: () => false,
            }
        } else {
            throw api.getResponseError(err)
        }
    }
}

/**
 * Get missions I am part of that do not belong to any org.
 *
 * For query parameters, see:
 * https://docs.api.missionx.ai/operation/operation-get-projects
 */
export async function getOrphanMissions(queryParams = {}, signal) {
    try {
        const qs = queryString.stringify(queryParams)
        const res = await api.get(`/v2/missions/orphans?${qs}`, { signal })

        return getPaginatedResponse({
            ...res.data,
            value: res.data?.value,
        })
    } catch (err) {
        if (err.name === "CanceledError") {
            return {
                value: [],
                nextLink: null,
                hasNext: () => false,
            }
        } else {
            throw api.getResponseError(err)
        }
    }
}

/**
 * For query parameters, see:
 * https://docs.api.missionx.ai/operation/operation-get-projects
 */
export async function getMyMissions(queryParams = {}, signal) {
    try {
        const qs = queryString.stringify({
            ...queryParams,
            participating: true,
        })
        const res = await api.get(`/v2/missions?${qs}`, { signal })

        return getPaginatedResponse({
            ...res.data,
            value: res.data?.value,
        })
    } catch (err) {
        if (err.name === "CanceledError") {
            if (err.name === "CanceledError") {
                return {
                    value: [],
                    nextLink: null,
                    hasNext: () => false,
                }
            }
        } else {
            throw api.getResponseError(err)
        }
    }
}

/**
 * For query parameters, see:
 * https://docs.api.missionx.ai/operation/operation-get-projects
 */
export async function getMissionsLite(queryParams = {}, signal) {
    try {
        const qs = queryString.stringify(queryParams)
        const res = await api.get(`/v2/missions/lite?${qs}`, { signal })

        return getPaginatedResponse({
            ...res.data,
            value: res.data?.value,
        })
    } catch (err) {
        throw api.getResponseError(err)
    }
}
export async function getMissionsRoadmap(queryParams = {}, signal) {
    try {
        const qs = queryString.stringify(queryParams)

        const res = await api.get(`/v2/missions/road-map?${qs}`, { signal })

        return getPaginatedResponse({
            ...res.data,
            value: res.data?.value,
        })
    } catch (err) {
        throw api.getResponseError(err)
    }
}
export async function getMissionsUltraLite(queryParams = {}, signal) {
    try {
        const qs = queryString.stringify(queryParams)

        const res = await api.get(`/v2/missions/ultralite?${qs}`, { signal })

        return getPaginatedResponse({
            ...res.data,
            value: res.data?.value,
        })
    } catch (err) {
        throw api.getResponseError(err)
    }
}
export async function getMissionsBudgetLean(queryParams = {}, signal) {
    try {
        const qs = queryString.stringify(queryParams)

        const res = await api.get(`/v2/missions/budget-lean?${qs}`, { signal })

        return getPaginatedResponse({
            ...res.data,
            value: res.data?.value,
        })
    } catch (err) {
        throw api.getResponseError(err)
    }
}
export async function getMissionsRefLite(queryParams = {}, signal) {
    try {
        const qs = queryString.stringify(queryParams)

        const res = await api.get(`/v2/missions/reflite?${qs}`, { signal })

        return getPaginatedResponse({
            ...res.data,
            value: res.data?.value,
        })
    } catch (err) {
        throw api.getResponseError(err)
    }
}

export async function getMissionStatusLite(queryParams = {}, signal) {
    //return _id, projectStatus, kickedOff 2000 max limit
    try {
        const qs = queryString.stringify(queryParams)
        const res = await api.get(`/v2/missions/statuslite?${qs}`, { signal })

        return getPaginatedResponse({
            ...res.data,
            value: res.data?.value,
        })
    } catch (err) {
        if (err.name === "CanceledError") {
            return {
                value: [],
                nextLink: null,
                hasNext: () => false,
            }
        } else {
            throw api.getResponseError(err)
        }
    }
}

export async function getMissionsFinancials(queryParams = {}, signal) {
    try {
        const qs = queryString.stringify(queryParams)
        const res = await api.get(`/v2/missions/org-financials?${qs}`, { signal })

        return getPaginatedResponse({
            ...res.data,
            value: res.data?.value,
        })
    } catch (err) {
        if (err.name === "CanceledError") {
            if (err.name === "CanceledError") {
                return {
                    value: [],
                    nextLink: null,
                    hasNext: () => false,
                }
            }
        } else {
            throw api.getResponseError(err)
        }
    }
}

export async function getClientMissionsLean(queryParams = {}, signal) {
    try {
        const qs = queryString.stringify(queryParams)
        const res = await api.get(`/v2/missions/client-missions-lean?${qs}`, { signal })

        return getPaginatedResponse({
            ...res.data,
            value: res.data?.value,
        })
    } catch (err) {
        if (err.name === "CanceledError") {
            if (err.name === "CanceledError") {
                return {
                    value: [],
                    nextLink: null,
                    hasNext: () => false,
                }
            }
        } else {
            throw api.getResponseError(err)
        }
    }
}
export async function getClientMissionsBudgetLean(queryParams = {}, signal) {
    try {
        const qs = queryString.stringify(queryParams)
        const res = await api.get(`/v2/missions/client-missions-budget-lean?${qs}`, { signal })

        return getPaginatedResponse({
            ...res.data,
            value: res.data?.value,
        })
    } catch (err) {
        if (err.name === "CanceledError") {
            if (err.name === "CanceledError") {
                return {
                    value: [],
                    nextLink: null,
                    hasNext: () => false,
                }
            }
        } else {
            throw api.getResponseError(err)
        }
    }
}
/**
 * For query parameters, see:
 * https://docs.api.missionx.ai/operation/operation-get-projects
 */
export async function getMissionsLiteIds(queryParams = {}, signal) {
    try {
        const qs = queryString.stringify(queryParams)
        const res = await api.get(`/v2/missions/lite/ids?${qs}`, { signal })

        return getPaginatedResponse({
            ...res.data,
            value: res.data?.value,
        })
    } catch (err) {
        if (err.name === "CanceledError") {
            if (err.name === "CanceledError") {
                return {
                    value: [],
                    nextLink: null,
                    hasNext: () => false,
                }
            }
        } else {
            throw api.getResponseError(err)
        }
    }
}

/**
 * The budget radar: what needs a look across the missions I run (admin or PM), read from
 * the stored financials. Missions of orgs without them are only counted, not judged.
 * @param [queryParams.tz] {String} IANA timezone, decides which month is "current".
 * @return {Promise<{ missions: Object[], counts: { missions, tracked, flagged, capped } }>}
 */
/** Hides a person's cost change from my budget radar only. */
export async function dismissBudgetRadarCostChange(id) {
    try {
        await api.post(`/v2/missions/budget-radar/cost-changes/${id}/dismiss`)
    } catch (err) {
        throw api.getResponseError(err)
    }
}

export async function getBudgetRadar(queryParams = {}, signal) {
    try {
        const qs = queryString.stringify(queryParams)
        const res = await api.get(`/v2/missions/budget-radar?${qs}`, { signal })
        return res.data
    } catch (err) {
        throw api.getResponseError(err)
    }
}
